<template>
  <div>

    <div class="error-page-block d-flex flex-column align-items-center">
      <Error504Img/>

      <p>
        Seems something went wrong. Let’s go to dashboard so that start the way from the very beginning
      </p>

      <router-link :to="$store.getters.GET_PATHS.dashboard">
        <MainButton
                class="wfc"
                :value="'Go to Dashboard'"
        />
      </router-link>

    </div>
  </div>
</template>

<script>
  import Error504Img from '../../../../public/img/common/504-img.svg?inline'
  import MainButton from "../../UI/buttons/MainButton/MainButton";

  export default {
    name: "Error504Module",

    components: {
      MainButton,
      Error504Img,
    },

    data() {
      return {

      }
    },

    created() {

    },

  }
</script>

<style scoped>

</style>
